/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Trouble_Old_Pc_AInputs */

const en_wc_dl_trouble_old_pc_a = /** @type {(inputs: Wc_Dl_Trouble_Old_Pc_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If your graphics card has no DirectX 12 driver, Windows falls back to software rendering. Update your graphics driver, or use the online version in a modern browser.`)
};

/**
* | output |
* | --- |
* | "If your graphics card has no DirectX 12 driver, Windows falls back to software rendering. Update your graphics driver, or use the online version in a modern ..." |
*
* @param {Wc_Dl_Trouble_Old_Pc_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_trouble_old_pc_a = /** @type {((inputs?: Wc_Dl_Trouble_Old_Pc_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Trouble_Old_Pc_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_trouble_old_pc_a(inputs)
});
export { wc_dl_trouble_old_pc_a as "wc.dl.trouble.old_pc.a" }